import { template } from "lodash";

export default {
  public: {
    loading: "Sobreprima...",
    ok: "DE ACUERDO",
    cancel: "Cancelar",
    back: "Atrás",
    userDefined: "Personalizado",
    edit: "Editar",
    clear: "Claro",
    delete: "Borrar",
    close: "Cerrar",
    remove: "Eliminar",
    preView: "Preestreno",
    replace: "Reemplazar",
    systemMsg: "Información",
    generateSuccess:
      "¡Su presentación de PowerPoint ha sido generada con éxito!",
    templateChoose:
      "Elija una plantilla para completar su propia creación de IA",
    templateChooseShort: "Elige una plantilla",
    templateChangeTips:
      "Reemplazar los datos de la plantilla restaurará su contenido original. El contenido modificado se perderá. ¿Está seguro de que desea continuar?",
    sourceInvalid:
      "La fuente de datos no es válida, por favor inténtelo de nuevo.",
    systemBusy: "El servidor está ocupado, por favor actualice la página.",
    templateReplaceSuccess:
      "La sustitución de la plantilla fue exitosa. Por favor, guarde manualmente, ya que el sistema no guardará automáticamente.",
    shareLinkTips:
      "La copia se realizó con éxito. ¡Redirigiendo la página web ahora!",
    noPermissionTips:
      "Lo siento, el autor ha cerrado los permisos de compartir esta presentación. ¡Puedes iniciar sesión en aippttv, mostrar tu imaginación y crear tu propia presentación!",
    copyTips: "¡Copia éxito!",
    loginTips: "¡Por favor inicia sesión primero!",
    bottomTag: "Hecho con {brand}",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "Fuente",
      sysFont: "Fuente del sistema",
      lineFont: "Fuente en línea",
      fontColor: "Color del texto",
      textColor: "Color de la fuente",
      fontDelay: "Resaltado de fuente",
      addSize: "Aumentar el tamaño de la fuente",
      duceSize: "Disminuir el tamaño de la fuente",
      left: "Alineación a la izquierda",
      middle: "Centro",
      horizontalCenter: "Centro horizontal",
      verticalCenter: "Centro vertical",
      right: "Alineación a la derecha",
      bottom: "Alineación inferior",
      top: "Alineación superior",
      bold: "Negrita",
      em: "Cursiva",
      underline: "Subrayar",
      strikethrough: "Tachado",
      richText: "Eliminar formato",
      textFormat: "Pincel de formato",
      addIndex: "Aumentar Sangría",
      duceIndex: "Disminuir Sangría",
      no: "Numeración",
      link: "Hipervínculo",
      inputLink: "Ingrese el hipervínculo",
      superscript: "Sobrescrito",
      subscript: "Subíndice",
      code: "Código en línea",
      blockquote: "Cita",
      horizontal: "Horizontal",
      vertical: "Vertical",
      width: "Ancho",
      height: "Altura",
      rotate: "Rotar",
      uniformHorizontal: "Distribuir Horizontalmente",
      uniformVertical: "Distribuir Verticalmente",
      combine: "Combinar",
      unCombine: "Desagrupar",
      bgColor: "Color de fondo",
      mainColor: "Color del tema",
      useMainToAll: "Aplicar tema a todos",
      preMain: "Tema predefinido",
    },
    specialEffects: {
      useAll: "Aplicar a todos",
      no: "Ninguno",
      fade: "Fundido de entrada/salida",
      slideX: "Deslizar a la izquierda/derecha",
      slideY: "Deslizar hacia arriba/abajo",
    },
  },
  chart: {
    insertCol: "Insertar columna",
    insertRow: "Insertar fila",
    delCol: "Eliminar columna",
    delRow: "Eliminar fila",
    merCell: "Combinar celdas",
    unMerCell: "Separar celdas",
    selectCurrentCol: "Seleccionar columna actual",
    selectCurrentRow: "Seleccionar fila actual",
    selectAll: "Seleccionar todas las celdas",
    toTheLeft: "A la izquierda",
    toTheRight: "A la derecha",
    toTheTop: "Hacia arriba",
    toTheBottom: "Hacia abajo",
  },  
  desktop: {
    fileExportSuccess:
      "El archivo se ha exportado correctamente. Seleccione una ubicación para guardar el archivo",
    unSupportPreviewPDF:
      "La vista previa en PDF no está disponible aquí. Si desea obtener una vista previa, visite el sitio web oficial para PC.",
  },

  extension: {
    nonsupportDownloadPDF:
      "El complemento del navegador no admite la descarga de PDF, por favor vaya al sitio web oficial para descargar",
  },
  index: {
    createText: "Generando contenido de PPT",
    createPage: "Generando contenido para la página {0}",
    haveProblem: "Tengo un problema",
    systemError: "{0}",
    saveText: "Guardado exitosamente",
    saveMessage: "¿Estás seguro de guardar?",
    cBtn: "Cancelar",
    sBtn: "DE ACUERDO",
    waitMsg:
      "Por favor, ten paciencia y espera de 30 a 40 segundos. Si no se genera, por favor actualiza tu navegador e inténtalo de nuevo.",
  },
  errorCode: {
    "401":
      "La autenticación falló, no se puede acceder a los recursos del sistema",
    "403": "La operación actual no está permitida",
    "404": "Recurso no encontrado",
    default:
      "Error del sistema desconocido, por favor, informe al administrador",
    notReDo: "Los datos se están procesando, por favor, no vuelva a enviarlos",
    loginMsg:
      "Sesión no válida o la sesión ha caducado. Por favor, inicie sesión nuevamente.",
    errMsg: "El sistema está ocupado, por favor, inténtelo de nuevo más tarde",
  },
  linkHandler: {
    pptPage: "Página de diapositivas",
    change: "Cambiar",
    remove: "Eliminar",
  },
  editor: {
    ctrlV: "Pegar",
    ctrlA: "Seleccionar todo",
    enter: "Nueva pagina",
    f5: "Presentación de diapositivas",
    delete: "Eliminar página",
    ctrlD: "Página duplicada",
    ctrlX: "Cortar",
    ctrlC: "Copiar",
    shiftF5: "Comenzar desde la Actual",
    positionPanel: {
      horizontalCenter: "Centrar horizontalmente",
      verticalCenter: "Centrar verticalmente",
      horizontalVerticalCenter: "Centrar horizontal y verticalmente",
      left: "Alinear a la izquierda",
      right: "Alinear a la derecha",
      top: "Alinear arriba",
      bottom: "Alinear abajo",
      onTop: "Poner en la parte superior",
      onBottom: "Poner en la parte inferior",
      levelUp: "Mover un nivel hacia arriba",
      levelDown: "Mover un nivel hacia abajo",
      setLink: "Establecer enlace",
      ungroup: "Desagrupar",
      group: "Agrupar",
      selectAll: "Seleccionar todo",
      lock: "Bloquear",
      unlock: "Descubrir",
      delete: "Eliminar",
    },
    canvas: {
      index: {
        ctrlR: "Regla",
        ctrlW: "Líneas de cuadrícula",
        nl: "Ninguno",
        small: "Pequeño",
        middle: "Medio",
        big: "Grande",
        closePan: "Cerrar panel de selección",
        openPan: "Abrir panel de selección",
        reCurrentPage: "Restablecer página actual",
        showPpt: "Presentación de diapositivas",
        generate:'Generando...'
      },
      linkDialog: {
        url: "Por favor, ingrese la dirección del enlace web",
        ppt: "Diapositivas",
        preView: "Preestreno",
        pageUrl: "Enlace web",
        pptPage: "Página de diapositivas",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "Deshacer",
        reSet: "Rehacer",
        text: "Insertar texto",
        horizontal: "Cuadro de texto horizontal",
        vertical: "Cuadro de texto vertical",
        image: "Insertar imagen",
        shape: "Insertar forma",
        line: "Insertar línea",
        chart: "Insertar gráfico",
        table: "Insertar tablae",
        gs: "Insertar fórmula",
        voice: "Insertar audio/video",
        screen: "Ajustar a la pantalla",
        workspase: "Espacio de trabajo",
        save: "Guardar",
        logo: "Insertar logotipo",
        close: "Cerrar PPT",
        share: "Compartir",
        download: "Descargar",
        templateReplacement: "Reemplazo de plantilla",
      },
      mediaInput: {
        videoUrl: "Ingrese la URL del video, por ejemplo, https://xxx.mp4",
        voiceUrl: "Ingrese la URL del audio, por ejemplo, https://xxx.mp3",
        video: "Video",
        voice: "Audio",
        videoError: "Por favor, primero ingrese una URL de video correcta",
        voiceError: "Por favor, primero ingrese una URL de audio correcta",
      },
      tableGenerator: {
        table: "Tabla",
        row: "Filas",
        column: "Columnas",
        rcError: "¡Las filas/columnas deben estar entre 0 y 20!",
      },
      logo: {
        text1: "Subir logotipo de la empresa",
        text2: "Ingrese el nombre de la empresa",
        companyNamePlaceholder: "Ingrese el nombre de su empresa",
        single: "Aplicación de una sola página",
        all: "Aplicar a todas las páginas",
        position: "posición",
      },
    },
    editorHeader: {
      index: {
        file: "Archivar",
        importPptistFile: "Importar archivo de pptist",
        importPptxFile: "Importar archivo pptx",
        exportPptxFile: "Exportar archivo",
        undo: "Deshacer",
        redo: "Rehacer",
        createSlide: "Agregar página",
        deleteSlide: "Eliminar página",
        closeGridLines: "Cerrar líneas de cuadrícula",
        openGridLines: "Abrir líneas de cuadrícula",
        closeRuler: "Cerrar regla",
        openRuler: "Abrir regla",
        resetSlides: "Restablecer diapositivas",
        closeSelectPanel: "Cerrar panel de selección",
        openSelectPanel: "Abrir panel de selección",
        f5: "Presente",
        enterScreeningFromStart: "Empezar desde el principio",
        enterScreening: "Comenzar desde la página actual",
        help: "Ayudar",
        hotkey: "Atajos de teclado",
        pptShow: "Presentación de diapositivas",
        export: "Exportar",
        importing: "Importador...",
        continue: "Continuar",
        pauseGeneration: "Pausa",
        noPricing:
          "Conviértase en miembro y disfrute de privilegios de descarga con nosotros.",
        noPricingToOpt: "Desbloquea todos los privilegios.",
        getTokens: "Actualízate a Pro",
        pptSlidesMsg:
          "¡Felicitaciones por crear {0} diapositivas PPT completas! ",
        Feedback: "Deje que la IA sea su asistente de trabajo.",
        giveAway: "Regalar cupones (válido por 30 minutos)",
        getItNow: "Consiguelo ahora",
        unlockAllPpt: "Desbloquea todas las funciones de PPT",
        grantPermission: "Conceder permiso para utilizar el mapa mental de IA",
        grantPermissionToUseGpt: "Conceder permiso para usar GPT",
        permissionCodeUse:
          "¡Por favor, recuerde el código de descuento y proceda a la página de pago para usarlo!",
        pptTi1:
          "Has completado todo el trabajo y has generado un total de {0} páginas de ppt. ",
        pptTi2:
          "¡Solo necesitas el último paso para obtener tu maravillosa creación de IA!",
      },
    },
    exportDialog: {
      tips:'La descarga de PPT no es compatible con la aplicación en este momento; descargue en la PC',
      exportScope: "Alcance de exportación",
      close: "Cerrar",
      all: "Todo",
      thisPage: "Actual",
      auto: "Personalizado",
      autoScope: "Rango personalizado",
      exporting: "Exportando...",
      exportImg: "Exportar imagen",
      expPdf: "Imprimir / Exportar PDF",
      expPptx: "Exportar PPTX",
      downloadSuccess:
        "La conversión del archivo fue exitosa. Por favor selecciona una ruta de guardado",
      exportImage: {
        exportType: "Formato de exportación",
        imageQuality: "Calidad de imagen",
        ignoreFont: "Ignorar fuentes en línea",
        ignoreLineFont:
          "De forma predeterminada, las fuentes en línea se ignorarán durante la exportación. Si has utilizado fuentes en línea en la presentación y deseas conservar sus estilos después de la exportación, puedes optar por desactivar la opción 'Ignorar fuentes en línea', pero ten en cuenta que esto puede aumentar el tiempo de exportación.",
      },
      exportPdf: {
        all: "Todas las diapositivas",
        thisPage: "Diapositiva actual",
        pageNum: "Páginas por hoja",
        white: "Margen",
        notice:
          "Nota: Si la vista previa de impresión no coincide con el estilo real, por favor verifica la opción 'Gráficos de fondo' en la ventana emergente de impresión.",
      },
      exportPPTX: {
        title: "Anular el maestro predeterminado",
        notice:
          "Nota: Después de descargarlo, por favor ábralo con Microsoft Office, ya que otros pueden no ser compatibles.",
      },
    },
    remark: {
      remark: "Haga clic para ingresar notas del orado",
    },
    thumbnails: {
      add: "Agregar diapositiva",
      slide: "Diapositiva",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "Recolorar (Máscara)",
          maskColor: "Color de máscara",
          opacity: "Opacidad",
        },
        elementFilter: {
          enableFilter: "Activar filtros",
          blur: "Difuminar",
          brightness: "Luminosidad",
          contrast: "Contraste",
          grayscale: "Escala de grises",
          saturate: "Saturar",
          hueRotate: "Rotar tono",
          opacity: "Opacidad",
        },
        elementFlip: {
          horizontal: "Voltear horizontalmente",
          vertical: "Voltear verticalmente",
        },
        elementOpacity: {
          opacity: "Opacidad",
        },
        elementOutline: {
          border: "Habilitar fronteras",
          borderStyle: "Estilo de borde",
          solid: "Borde sólido",
          dashes: "Borde discontinuo",
          borderColor: "Color del borde",
          borderWeight: "Grosor del borde",
        },
        elementShadow: {
          enable: "Hhabilitar sombra",
          horizontal: "Sombra horizontal",
          vertical: "Sombra vertical",
          fuzzyDistance: "Distancia de desenfoque",
          color: "Color de sombra",
        },
      },
      panel: {
        background: "Relleno de fondo",
        solid: "Relleno de color sólido",
        image: "Relleno de imagen",
        gradient: "Relleno de degradado",
        contain: "Ajustar",
        repeat: "Collage",
        cover: "Apto para llenar",
        linear: "Degradado lineal",
        radial: "Degradado radial",
        startColor: "Color de inicio",
        endColor: "Color de fin",
        rotate: "Ángulo del degradado",
        useBackgroundToAll: "Aplicar fondo a todos",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "Categoría",
            colType: "Serie",
          },
          index: {
            edit: "Editar datos del gráfico",
            area: "Estilo de gráfico de áreas",
            line: "Estilo de gráfico de dispersión",
            lineSmooth: "Usar línea suave",
            horizontalBars: "Estilo de gráfico de barras",
            stackBars: "Estilo apilado",
            donut: "Estilo de gráfico de anillos",
            img: "Leyenda",
            hidden: "No mostrar",
            showTop: "Mostrar en la parte superior",
            showBottom: "Mostrar en la parte inferior",
            tabColor: "Color de cuadrícula",
            labelColor: "Color de fuente",
            titleSetColor: "Colores del tema:",
            title: "Temas recomendados",
            titleColor: "Agregar color de tema",
          },
        },
        audioStylePanel: {
          imgColor: "Color del icono",
          autoPlay: "Reproducción automática",
          loopPlay: "Reproducción en bucle",
        },
        imageStylePanel: {
          cutImg: "Recortar imagen",
          shape: "Por forma",
          type: "Categoría",
          preview: "Preestreno",
          use: "Uso",
          searchByType: "Buscar por categoría",
          uploadAndReplace: "Cargar y reemplazar imagen",
          reSetStyle: "Restablecer estilo",
          setBackground: "Establecer como fondo",
          clip1: "Por relación de aspecto (Cuadrado)",
          clip2: "Por relación de aspecto (Vertical)",
          clip3: "Por relación de aspecto (Horizontal)",
        },
        latexStylePanel: {
          edit: "Editar LaTeX",
          color: "Color",
          bold: "Negrita",
        },
        lineStylePanel: {
          style: "Estilo de línea",
          solid: "Línea sólida",
          dotted: "Línea punteada",
          color: "Color de linea",
          weight: "Ancho de línea",
          startStyle: "Estilo de punto de partida",
          endStyle: "Estilo de punto final",
          none: "Ninguno",
          arrow: "Flecha",
          dot: "Punto",
        },
        multiStylePanel: {
          colorPicker: "Color de relleno",
          style: "Estilo de borde",
          solid: "Borde sólido",
          dotted: "Borde punteado",
          color: "Color del borde",
          weight: "Ancho del borde",
        },
        shapeStylePanel: {
          replaceShade: "Haz clic para reemplazar la forma",
          fill: "Relleno sólido",
          gradient: "Relleno degradado",
          linear: "Degradado Lineal",
          radial: "Degradado Radial",
        },
        tableStylePanel: {
          colFull: "Relleno de celda",
          row: "Filas",
          col: "Columns",
          titleRow: "Fila de título",
          totalRow: "Fila total",
          firstCol: "Primera Columna",
          lastCol: "Última Columna",
          titleColor: "Color del Tema",
          themeTable: "Tabla de Temas",
        },
        textStylePanel: {
          urlError: "No es una dirección web correcta",
          command: "Lista con viñetas",
          lineHeight: "Espaciado entre líneas",
          times: "veces",
          paragraphSpace: "Espaciado de párrafos",
          wordSpace: "Espaciado de palabras",
          textIndent: "Sangría de primera línea",
          textFill: "Relleno de cuadro de texto",
          title: "Título",
          titleSmall: "Subtitular",
          text: "Texto",
          textSmall: "Texto [Pequeño]",
          zs1: "Nota 1",
          zs2: "Nota 2",
        },
        videoStylePanel: {
          cover: "Portada de Vista Previa del Video",
          recover: "Restablecer Portada",
        },
      },
      elementAnimationPanel: {
        addEffects: "Agregar Animación",
        selectAndAddEffects:
          "Seleccionar Elementos en el Lienzo y Agregar Animación",
        time: "Duración",
        triggerType: "Tipo de Activador",
        initiative: "Disparador de Iniciativa",
        sameTime: "Al mismo tiempo que el Anterior",
        after: "Después del Anterior",
        change: "Cambiar Animación",
        in: "Entrada",
        out: "Salida",
        attention: "Énfasis",
      },
      elementPositionPanel: {
        layer: "Capa",
        align: "Alinear",
        top: "Llevar al Frente",
        bottom: "Establecer al final",
        up: "Traer Adelante",
        down: "Enviar Atrás",
        noRixedRatio: "Desbloquear Proporciones",
        fixedRatio: "Bloquear Proporciones",
      },
      index: {
        style: "Estilo",
        symbol: "Símbolo",
        position: "Posición",
        animation: "Animación",
        design: "Diseño",
        slideAnimation: "Transiciones",
      },
      slideDesignPanel: {
        canvasSize: "Tamaño del lienzo",
        wideScreen1: "Pantalla Ancha 16:9",
        wideScreen2: "Pantalla Ancha 16:10",
        standard: "Estándar 4:3",
        paper: "Papel A3 / A4",
        title: "Tema global",
        mainColor: "Color del tema",
        useMainToAll: "Aplicar tema a todos",
        preMain: "Tema predefinido",
        text: "Texto Aa",
        use: "Aplicar",
        useToAll: "Aplicar todo",
      },
    },
    selectPanel: {
      select: "Seleccionar",
      showAll: "Mostrar todo",
      hideAll: "Ocultar todo",
      group: "Grupo",
    },
    redraw: {
      topLabel: "Redibujar",
      msgTips: "Por favor, introduzca el contenido generado.",
      retext: "Redibujar",
      cltext: "Cancelar",
      btnText: "Crear",
      reConfirm:
        "Generar esto reemplazará la página actual y no guardará el contenido histórico. ¿Estás seguro de que quieres continuar?",
      confirmBtnTxt: "Continuar",
    },
  },
  screen: {
    presenter: {
      normalView: "Vista normal",
      pen: "Bolígrafo",
      laserPointer: "Puntero láser",
      timer: "Temporizador",
      exitFullScreen: "Salir de pantalla completa",
      fullScreen: "Pantalla completa",
      endPresentation: "Finalizar presentación",
      speakerNotes: "Notas del orador",
      speakersView: "Vista del orador",
      previousPage: "Pagina anterior",
      nextPage: "Página Siguiente",
      firstPage: "Primera Página",
      lastPage: "Última Página",
      brushTool: "Herramienta de Pincel",
      noRemarks: "sin observaciones",
      lastPageTips: "Ya es la última página",
      firstPageTips: "Ya es la primera página",
      autoPlay: "Iniciar presentación automática"
    },
    writingBoard: {
      inkThickness: "Grosor de la tinta",
      eraserSize: "Tamaño del borrador",
      eraser: "Borrador",
      clearInk: "Tinta transparente",
      blackboard: "Pizarra",
      closeBrush: "Cerrar pincel",
    },
  },
  mobile: {
    index: {
      notSupport: "La versión móvil se está desarrollando con urgencia.",
      toPc: "Por favor, visite el sitio web en una PC.",
      editTips: "Por favor, edite en la PC.",
    },
  },
  useCreateElement: {
    type: "Tipo{0}",
    class: "Serie{0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "Ingrese la fórmula de LaTeX",
        preViw: "Vista previa de la fórmula",
        symbol: "Símbolos comunes",
        formula: "Fórmulas predefinidas",
        error: "La fórmula no puede estar vacía",
      },
    },
    colorPicker: {
      recentUse: "Uso reciente",
    },
  },
  config: {
    latex: {
      gauss: "Fórmula Gaussiana",
      fourierSeries: "Serie de Fourie",
      taylorExpansion: "Expansión de Taylor",
      definiteIntegral: "Integral Definida",
      trigonometricIdentity1: "Identidad Trigonométrica 1",
      trigonometricIdentity2: "Identidad Trigonométrica 2",
      expansion: "Expansión de Suma",
      euler: "Fórmula de Euler",
      differential: "Ecuación de Bernoulli",
      totalDifferentialEquation: "Ecuación Diferencial Total",
      homogeneous: "Ecuación No Homogénea",
      cauchy: "Teorema del Valor Medio de Cauchy",
      lagrange: "Teorema del Valor Medio de Lagrange",
      arcsin: "Fórmula de Derivada",
      trigonometric: "Integración de Funciones Trigonométricas",
      quadric: "Superficie Cuadrática",
      dx: "Diferencial de Segundo Orden",
      partial: "Derivada Direccional",
      operators: "Operadores Matemáticos",
      group: "Combinaciones",
      verbatim: "Funciones",
      greek: "Letras Griegas",
    },
    symbol: {
      letter: "letras",
      number: "Número",
      math: "Matemáticas",
      arrow: "Flecha",
      graph: "Grafico",
    },
    lines: {
      straight: "línea recta",
      brokenOrCurve: "Roto o curva",
    },
  },
  hotkey: {
    opt: {
      common: "Común",
      ctrlX: "Cortar",
      ctrlC: "Copiar",
      ctrlV: "Pegar",
      ctrlD: "Copiar y pegar rápido",
      ctrlA: "Seleccionar todo",
      ctrlZ: "Undo",
      ctrlY: "Redo",
      del: "Borrar",
      ctrlMore: "Selección múltiple",
      ctrlP: "Imprimir",
      esc: "Cerrar elemento emergente",
    },
    slide: {
      show: "Presentación de diapositivas",
      edit: "Editar diapositiva",
      first: "Iniciar la presentación desde el principio.",
      current: "Iniciar la presentación desde la diapositiva actual",
      spacePre: "Cambiar a la página anterior",
      spaceNext1: "Cambiar a la página siguiente",
      spaceNext2: "Cambiar a la página siguiente",
      out: "Salir de Presentación",
      new: "Nuevo tobogán",
      move: "Mover lienzo",
      upOrDown: "Lienzo de zoom",
      up: "Ampliar lienzo",
      down: "Alejar lienzo",
      screen: "Ajustar lienzo a la pantalla actual",
      noSelectPrePage: "Página anterior (Elementos no seleccionados)",
      noSelectNextPage: "Página siguiente (Elementos no seleccionados)",
      prePage: "Página Anterior",
      nextPage: "Página Siguiente",
    },
    element: {
      opt: "Operaciones de elementos",
      move: "Mover",
      lock: "Bloquear",
      combo: "Grupo",
      cancelCombo: "Desagrupar",
      top: "Traer al Frente",
      bottom: "Enviar al Fondo",
      h: "Bloquear Relación de Aspecto",
      v: "Crear Línea Horizontal / Vertical",
      change: "Cambiar Elemento de Enfoque",
      com: "Confirmar Recorte de Imagen",
      text: "texto",
      image: "imagen",
      shape: "forma",
      line: "línea",
      chart: "cuadro",
      table: "gráfico",
      video: "video",
      audio: "audio",
      latex: "Fórmula",
    },
    table: {
      edit: "Edición de Tabla",
      nextCol: "Enfocar en la Celda Siguiente",
      insertTop: "Insertar Fila Arriba",
      insertBottom: "Insertar Fila Abajo",
      insertLeft: "Insertar Columna a la Izquierda",
      insertRight: "Insertar Columna a la Derecha",
    },
    chat: {
      edit: "Edición de Datos del Gráfico",
      nextLine: "Enfocar en la Línea Siguiente",
    },
    text: {
      edit: "Editar texto",
      bold: "Negrita",
      italics: "Cursiva",
      underline: "Subrayar",
      delLine: "Tachado",
    },
  },
  shape: {
    rectangle: "Rectángulo",
    commonUse: "Formas comunes",
    arrow: "Flecha",
    other: "Otras formas",
    line: "Línea",
  },
  animation: {
    in: {
      bounce: "rebotar",
      bounceIn: "rebotarAdentro",
      bounceInLeft: "rebotarAdentroIzquierda",
      bounceInRight: "rebotarAdentroDerecha",
      bounceInUp: "rebotarAdentroArriba",
      bounceInDown: "rebotarAdentroAbajo",
      fade: "desvanecer",
      fadeIn: "desvanecerEntrando",
      fadeInDown: "desvanecerEntrandoAbajo",
      fadeInDownBig: "desvanecerEntrandoAbajoGrande",
      fadeInLeft: "desvanecerEntrandoIzquierda",
      fadeInLeftBig: "desvanecerEntrandoIzquierdaGrande",
      fadeInRight: "desvanecerEntrandoDerecha",
      fadeInRightBig: "desvanecerEntrandoDerechaGrande",
      fadeInUp: "desvanecerEntrandoArriba",
      fadeInUpBig: "desvanecerEntrandoArribaGrande",
      fadeInTopLeft: "desvanecerEntrandoArribaIzquierda",
      fadeInTopRight: "desvanecerEntrandoArribaDerecha",
      fadeInBottomLeft: "desvanecerEntrandoAbajoIzquierda",
      fadeInBottomRight: "desvanecerEntrandoAbajoDerecha",
      rotate: "rotar",
      rotateIn: "rotarEntrando",
      rotateInDownLeft: "rotarEntrandoAbajoIzquierda",
      rotateInDownRight: "rotarEntrandoAbajoDerecha",
      rotateInUpLeft: "rotarEntrandoArribaIzquierda",
      rotateInUpRight: "rotarEntrandoArribaDerecha",
      zoom: "zoom",
      zoomIn: "zoomEntrando",
      zoomInDown: "zoomEntrandoAbajo",
      zoomInLeft: "zoomEntrandoIzquierda",
      zoomInRight: "zoomEntrandoDerecha",
      zoomInUp: "zoomEntrandoArriba",
      slide: "deslizar",
      slideInDown: "deslizarEntrandoAbajo",
      slideInLeft: "deslizarEntrandoIzquierda",
      slideInRight: "deslizarEntrandoDerecha",
      slideInUp: "deslizarEntrandoArriba",
      flip: "voltear",
      flipInX: "voltearEnX",
      flipInY: "voltearEnY",
      back: "atrás",
      backInDown: "atrásEntrandoAbajo",
      backInLeft: "atrásEntrandoIzquierda",
      backInRight: "atrásEntrandoDerecha",
      backInUp: "atrásEntrandoArriba",
      lightSpeed: "velocidadLigera",
      lightSpeedInRight: "velocidadLigeraEntrandoDerecha",
      lightSpeedInLeft: "velocidadLigeraEntrandoIzquierda",
    },
    out: {
      bounce: "rebotar",
      bounceOut: "reboteFuera",
      bounceOutLeft: "reboteFueraIzquierda",
      bounceOutRight: "reboteFueraDerecha",
      bounceOutUp: "reboteFueraArriba",
      bounceOutDown: "reboteFueraAbajo",
      fade: "desvanecer",
      fadeOut: "desvanecerSalir",
      fadeOutDown: "desvanecerSalirAbajo",
      fadeOutDownBig: "desvanecerSalirAbajoGrande",
      fadeOutLeft: "desvanecerSalirIzquierda",
      fadeOutLeftBig: "desvanecerSalirIzquierdaGrande",
      fadeOutRight: "desvanecerSalirDerecha",
      fadeOutRightBig: "desvanecerSalirDerechaGrande",
      fadeOutUp: "desvanecerSalirArriba",
      fadeOutUpBig: "desvanecerSalirArribaGrande",
      fadeOutTopLeft: "desvanecerSalirArribaIzquierda",
      fadeOutTopRight: "desvanecerSalirArribaDerecha",
      fadeOutBottomLeft: "desvanecerSalirAbajoIzquierda",
      fadeOutBottomRight: "desvanecerSalirAbajoDerecha",
      rotate: "rotar",
      rotateOut: "rotarSalir",
      rotateOutDownLeft: "rotarSalirAbajoIzquierda",
      rotateOutDownRight: "rotarSalirAbajoDerecha",
      rotateOutUpLeft: "rotarSalirArribaIzquierda",
      rotateOutUpRight: "rotarSalirArribaDerecha",
      zoom: "zoom",
      zoomOut: "alejar",
      zoomOutDown: "alejarAbajo",
      zoomOutLeft: "alejarIzquierda",
      zoomOutRight: "alejarDerecha",
      zoomOutUp: "alejarArriba",
      slide: "deslizar",
      slideOutDown: "deslizarSalirAbajo",
      slideOutLeft: "deslizarSalirIzquierda",
      slideOutRight: "deslizarSalirDerecha",
      slideOutUp: "deslizarSalirArriba",
      flip: "voltear",
      flipOutX: "voltearHaciaAfueraX",
      flipOutY: "voltearHaciaAfueraY",
      back: "atrás",
      backOutDown: "salirHaciaAtrásAbajo",
      backOutLeft: "salirHaciaAtrásIzquierda",
      backOutRight: "salirHaciaAtrásDerecha",
      backOutUp: "salirHaciaAtrásArriba",
      lightSpeed: "velocidadLigera",
      lightSpeedOutRight: "velocidadLigeraHaciaAfueraDerecha",
      lightSpeedOutLeft: "velocidadLigeraHaciaAfueraIzquierda",
    },
    attention: {
      shake: "sacudir",
      shakeX: "sacudirX",
      shakeY: "sacudirY",
      headShake: "sacudidaDeCabeza",
      swing: "balanceo",
      wobble: "tambalearse",
      tada: "tada",
      jello: "gelatina",
      other: "otro",
      bounce: "rebote",
      flash: "destello",
      pulse: "pulso",
      rubberBand: "bandaDeGoma",
      heartBeat: "latidoDeCorazón",
    },
  },
  requestError: {
    tokenExpires:
      "Error de autenticación, no se pueden acceder a los recursos del sistema",
    permissionDenied: "Operación actual no permitida",
    notFound: "Recurso no encontrado",
    default:
      "Error del sistema desconocido, por favor informar al administrador",
    exceptionReminder: "Recordatorio de excepción",
    pleaseLogin:
      "La sesión es inválida o ha expirado, por favor inicie sesión nuevamente.",
    networkError: "Error de red",
    requestTimeOut: "Tiempo de espera de solicitud de interfaz del sistema",
    requestFailed: "Solicitud fallida",
  },
  promptsText: {
    theme: [
      "¡Explora diferentes temas y descubre diversión sin fin!",
      "¡Haz clic en cada página de tema y emprende un viaje mágico!",
      "Cada tema tiene su propio encanto único, ¿por qué no explorarlos todos?",
      "Bienvenido al mundo de los temas, elige tus intereses y comienza tu aventura",
      "¡Tu primera presentación de diapositivas de IA está a punto de llegar, mantente atento!",
      "¡Emprende un viaje de diapositivas, la salida es inminente...",
      "¿Listo para un nuevo festín visual? La presentación de diapositivas está a punto de comenzar...",
      "¡Aguanta fuerte! Próxima parada, el fantástico viaje de diapositivas...",
      "¡Rápido! ¡Cierra los ojos y espera a que llegue la sorpresa de la presentación de diapositivas...",
      "El mundo de la presentación de diapositivas está a punto de desplegarse ante ti, mantente atento...",
      "Por favor, ten paciencia, el sueño de la presentación de diapositivas está a punto de hacerse realidad...",
    ],
    directory: [
      "¡Encuentra todo lo que necesitas en la página del directorio!",
      "La página del directorio es tu tesoro de navegación, ¡facilitándote encontrar lo que necesitas!",
      "La página del directorio ofrece servicios de navegación completos, ¡permitiéndote encontrar tus objetivos rápidamente!",
      "¿No estás seguro a dónde ir? ¡Encuentra inspiración y dirección en la página del directorio!",
    ],
    Content: [
      "A la espera... ¡la siguiente diapositiva será tan colorida como un arcoíris!",
      "¡Wow! ¡La siguiente diapositiva florecerá como fuegos artificiales, dejándote asombrado!",
      "Ten paciencia, ¡la siguiente diapositiva será tan maravillosa como esperar que aparezca un arcoíris soñador!",
      "¡Siente la magia de la espera! ¡La siguiente diapositiva iluminará tus ojos!",
      "¡Mantente atento! ¡La siguiente diapositiva te traerá un festín visual sorpresa!",
      "¡Rápido! ¡Corre las cortinas y prepárate para abrazar la deslumbrante luz de la siguiente diapositiva!",
      "¡Prepárate! ¡La siguiente diapositiva traerá una nueva tormenta visual!",
      "¡Tu curiosidad está a punto de ser satisfecha! ¡La siguiente diapositiva te sorprenderá!",
      "A la espera... ¡la siguiente diapositiva te llevará en un maravilloso viaje visual!",
      "¿No puedes esperar? ¡La siguiente diapositiva será tan emocionante como una gran celebración!",
      "¿Adivina qué será la siguiente diapositiva? ¡La respuesta está a punto de ser revelada...",
      "Por favor, abróchese el cinturón de seguridad, estamos a punto de volar hacia la siguiente diapositiva...",
      "¡La felicidad está llegando! La siguiente diapositiva se dirige hacia ti a toda velocidad...",
      "¿Adivina de qué color será la siguiente diapositiva? La respuesta está a punto de ser revelada...",
      "¡Wow! La siguiente diapositiva te traerá sorpresas inesperadas...",
      "¿Ansioso por probar? La siguiente diapositiva satisfará tu curiosidad...",
      "A la espera... ¡la siguiente diapositiva te traerá alegría y sorpresas...",
      "A la espera... justo como esperar por una deliciosa taza de café, ¡la siguiente diapositiva deleitará tu estado de ánimo!",
      "Cierra los ojos, cuenta hasta tres, ¡la siguiente diapositiva traerá sorpresas! 1... 2... 3...",
      "¡En aventura! ¡Esperar la siguiente diapositiva es tan emocionante como descubrir un tesoro!",
      "¿Estás listo? ¡La siguiente diapositiva te llevará en una maravillosa aventura!",
    ],
    Comprehensive: [
      "Poco a poco, ¡explora el mundo interminable de diversión!",
      "Desde temas hasta directorios, y luego a páginas de contenido, ¡cada paso es un viaje de descubrimiento!",
      "¡Embárcate en un maravilloso viaje juntos, dejando nuestras huellas en este emocionante mundo!",
      "En este sorprendente sitio web, ¡descubramos más juntos!",
    ],
    Unpurchased: [
      "¿Ansioso por probar? ¡La siguiente diapositiva dará inicio a un festín visual, ven y únete a nosotros!",
      "Más que solo productos, ¡es una forma de vida! ¡Haz clic para comprar y deja volar tu estado de ánimo!",
      "Aquí, no solo estás comprando productos, ¡sino también comprando felicidad en abundancia!",
      "¡Únete como miembro y comienza un nuevo capítulo de vida llena de alegría!",
      "Haz clic para comprar y ¡haz que cada día esté lleno de sorpresas y diversión!",
      "¡Comprar es más que una acción, es una forma de disfrutar la vida!",
      "Aprovecha la oportunidad, compra los productos que deseas y ¡haz que la vida sea más colorida!",
      "Comprar es una maravillosa aventura, ¡vamos a emprender este viaje juntos!",
      "Haz clic para comprar, ¡tráete una sorpresa y felicidad!",
      "Comprar es una expresión, ¡vamos a elegir con el corazón juntos!",
    ],
  },
};
